import React from 'react';

interface ThemeToggleProps {
  theme: 'light' | 'dark' | 'system';
  toggleTheme: () => void;
  getThemeIcon: () => React.ComponentType;
  getThemeText: () => string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  theme,
  toggleTheme,
  getThemeIcon,
  getThemeText
}) => {
  const ThemeIcon = getThemeIcon();

  return (
    <button
      onClick={toggleTheme}
      className="w-full flex items-center px-4 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700"
    >
      <ThemeIcon size={16} className="mr-2" />
      {getThemeText()}
    </button>
  );
};